export const getAppStyles = () => ({
  appContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden"
  },

  contentArea: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    minHeight: 0
  },

  sidePanel: {
    padding: "1rem",
    overflowY: "auto",
    height: "100vh",
    borderRight: "1px solid var(--panel-border)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },

  mainPanel: {
    flex: 1,
    paddingTop: "1rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    // paddingBottom controlled by .main-panel-container-div CSS class so the
    // mobile @media override (safe-area-inset-bottom) is not clobbered by an
    // inline style.
    overflow: "hidden",
    height: "100vh",
    minHeight: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column"
  },

  scrollArea: {
    flex: 1,
    overflowY: "auto",
    minHeight: 0,
    paddingBottom: "1rem"
  },
});

